import React, { Component } from "react";
import { Link } from "react-router-dom";

import Logo from "../logo.png";

export default class Navbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isNavbarOpen: false
    };
  }

  handleNavbar = () => {
    this.setState({
      isNavbarOpen: !this.state.isNavbarOpen
    });
  };

  render() {
    const { isNavbarOpen } = this.state;
    return (
      <nav className="navbar navbar-expand-lg">
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img src={Logo} alt="Logo" />
          </Link>
          <button
            onClick={this.handleNavbar}
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNav"
            aria-controls="navbarNav"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon">
              <i className="fa fa-bars"></i>
            </span>
          </button>
          <div
            className={`collapse navbar-collapse ${
              isNavbarOpen ? "show" : "hide"
            }`}
            id="navbarNav"
          >
            <ul className="navbar-nav ml-auto">
              <li className="nav-item active">
                <Link className="nav-link" to="/support">
                  Support
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/offer">
                  24tkt Offers
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/login">
                  Agent Login
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}
